/**
 * @generated SignedSource<<91c0e634b247b43787bdf0578b3f9818>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationsTabQuery$variables = {
  id: string;
};
export type IntegrationsTabQuery$data = {
  readonly brand: {
    readonly " $fragmentSpreads": FragmentRefs<"IntegrationsTab_brand">;
  };
};
export type IntegrationsTabQuery = {
  response: IntegrationsTabQuery$data;
  variables: IntegrationsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IntegrationsTab_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandAppConfigType",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLBrandTrackingConfig",
                "kind": "LinkedField",
                "name": "trackingConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "consentSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "nonConsentSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "consentSessionStorageSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "nonConsentSessionStorageSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "consentLocalStorageSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TrackingConfigSetting",
                    "kind": "LinkedField",
                    "name": "nonConsentLocalStorageSettings",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "configType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "websiteId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "iosAppIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "androidAppIdentifier",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discourseContactEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slackUserInstalledChannels",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasFacebookAppSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookClientToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookLoginEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleIosClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleWebClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleLoginEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandShopifyConfigType",
            "kind": "LinkedField",
            "name": "shopifyConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "multipassEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isNewCustomerAccountsEnabled",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gorgiasId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasKlaviyoApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kinnApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasKustomerApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasOmetriaApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emarsysApiClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasEmarsysApiClientSecret",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasRechargeApiToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appsflyerDevKey",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a231e0899eccfc306e880bf43ab80204",
    "id": null,
    "metadata": {},
    "name": "IntegrationsTabQuery",
    "operationKind": "query",
    "text": "query IntegrationsTabQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    ...IntegrationsTab_brand\n    id\n  }\n}\n\nfragment CookiesCardCustomInput_trackingConfig on GraphQLBrandTrackingConfig {\n  consentSettings {\n    name\n    enabled\n  }\n  nonConsentSettings {\n    name\n    enabled\n  }\n  consentSessionStorageSettings {\n    name\n    enabled\n  }\n  nonConsentSessionStorageSettings {\n    name\n    enabled\n  }\n  consentLocalStorageSettings {\n    name\n    enabled\n  }\n  nonConsentLocalStorageSettings {\n    name\n    enabled\n  }\n}\n\nfragment CookiesCard_brand on BrandType {\n  appConfig {\n    id\n    trackingConfig {\n      ...CookiesCardCustomInput_trackingConfig\n      id\n      configType\n      consentSettings {\n        name\n        enabled\n      }\n      nonConsentSettings {\n        name\n        enabled\n      }\n      consentSessionStorageSettings {\n        name\n        enabled\n      }\n      nonConsentSessionStorageSettings {\n        name\n        enabled\n      }\n      consentLocalStorageSettings {\n        name\n        enabled\n      }\n      nonConsentLocalStorageSettings {\n        name\n        enabled\n      }\n      websiteId\n    }\n  }\n}\n\nfragment DiscourseCard_brand on BrandType {\n  discourseContactEmail\n  ...useBrandUpdateMutation_brand\n}\n\nfragment IntegrationsTab_brand on BrandType {\n  ...useBrandUpdateMutation_brand\n  ...CookiesCard_brand\n  ...DiscourseCard_brand\n  ...SlackCard_brand\n  ...SocialLoginCard_brand\n  gorgiasId\n  hasKlaviyoApiToken\n  kinnApiToken\n  hasKustomerApiToken\n  hasOmetriaApiToken\n  emarsysApiClientId\n  hasEmarsysApiClientSecret\n  hasRechargeApiToken\n  appsflyerDevKey\n}\n\nfragment SlackCard_brand on BrandType {\n  slackUserInstalledChannels\n}\n\nfragment SocialLoginCard_brand on BrandType {\n  ...useBrandUpdateMutation_brand\n  facebookAppId\n  hasFacebookAppSecret\n  facebookClientToken\n  facebookLoginEnabled\n  googleIosClientId\n  googleWebClientId\n  googleLoginEnabled\n  appConfig {\n    id\n    iosAppIdentifier\n    androidAppIdentifier\n  }\n  shopifyConfig {\n    multipassEnabled\n    isNewCustomerAccountsEnabled\n    id\n  }\n}\n\nfragment useBrandUpdateMutation_brand on BrandType {\n  id\n}\n"
  }
};
})();

(node as any).hash = "071b956b2e400d6f2cbed958424d5562";

export default node;
